module.exports = __webpack_public_path__ + "img/38.76507d22.png";